import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon_tiktok"
      height="1.5em"
      viewBox="0 0 24 24"
      width="1.5em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24 12A12 12 0 1112 0a12 12 0 0112 12z" fill="#fe2c55" />
      <path
        d="M12.308 5.012c.763-.012 1.522 0 2.281-.012a3.636 3.636 0 001.02 2.434 4.12 4.12 0 002.473 1.043v2.349a6.177 6.177 0 01-2.449-.564 7.207 7.207 0 01-.947-.543c0 1.705.008 3.406-.01 5.105a4.442 4.442 0 01-.789 2.3 4.343 4.343 0 01-3.448 1.872 4.254 4.254 0 01-2.379-.6 4.393 4.393 0 01-2.127-3.331 9.689 9.689 0 01-.007-.868 4.395 4.395 0 015.091-3.9c.013.864-.021 1.727-.021 2.591a2.007 2.007 0 00-2.558 1.237 2.316 2.316 0 00-.079.939 1.992 1.992 0 003.658.736 1.39 1.39 0 00.239-.62c.057-1.043.034-2.082.041-3.126.006-2.351-.007-4.7.011-7.041z"
        fill="#fff"
      />
    </svg>
  );
}
